import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chip", "row", "dayBlock"]

  filter(event) {
    const filter = event.currentTarget.dataset.filter

    this.chipTargets.forEach(c => c.classList.toggle("active", c.dataset.filter === filter))

    const visibleDays = new Set()

    this.rowTargets.forEach(row => {
      const show = filter === "all" || row.dataset[filter] === "true"
      row.style.display = show ? "" : "none"
      if (show) visibleDays.add(row.dataset.day)
    })

    this.dayBlockTargets.forEach(block => {
      block.style.display = visibleDays.has(block.dataset.day) ? "" : "none"
    })
  }
}
